import { EmptyPageContainer } from './EmptyPage.style'

const EmptyPage = (props) => {
    const { children } = props
    return (
        <EmptyPageContainer>
            { children }
        </EmptyPageContainer>
    )
}

export default EmptyPage